export default __webpack_public_path__ + "static/media/gotitan2026-popup-banner.1a78e2b4.jpg";